import React, { useEffect, useState } from 'react';
import { useDolar } from '../../context/ValorDolarContext';

function DolarOficial({ menuAbierto }) {
  const { valorDolar, actualizarValorDolar } = useDolar(); // Extraemos funciones del contexto
  const [dolar, setDolar] = useState({ venta: "-" });

  useEffect(() => {
    fetch("https://dolarapi.com/v1/dolares/oficial")
      .then((response) => response.json())
      .then((data) => {
        setDolar(data); // Actualizamos el estado local
        actualizarValorDolar(data.venta); // Actualizamos el estado global
      });
  }, [actualizarValorDolar]);

  return (
    !menuAbierto ? (
      <div className="flex flex-col bg-Verde h-9 xl:h-10 w-40 xl:w-48 mr-10 justify-center items-center text-center rounded">
        <label className="font-bold text-sm xl:text-base text-Blanco">
          {`Dolar Oficial: $ ${dolar.venta}`}
        </label>
      </div>
    ) : (
      <div className="flex flex-col bg-Verde h-10 w-44 justify-center items-center text-center rounded">
        <label className="font-bold text-base text-Blanco">
          {`Dolar Oficial: $ ${dolar.venta}`}
        </label>
      </div>
    )
  );
}

export default DolarOficial;
